import { render, staticRenderFns } from "./CustomMultiSelect.vue?vue&type=template&id=1ff39c42"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomMultiSelect.vue?vue&type=style&index=0&id=1ff39c42&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports